<script setup lang="ts">
import SwitchLocale from '../switch-locale.vue';
import NotificationsMenu from './notifications-menu.vue';
import ThemeToggle from './theme-toggle.vue';
import TutorialButton from './tutorial-button.vue';

const { loggedIn } = useUserSession();
</script>

<template>
  <div class="flex flex-col gap-2 space-x-2 sm:flex-row sm:gap-0">
    <SwitchCompany v-if="loggedIn" />
    <div class="flex items-center space-x-2">
      <SwitchLocale v-if="loggedIn" />
      <ThemeToggle />
      <TutorialButton v-if="loggedIn" />
      <NotificationsMenu v-if="loggedIn" />
    </div>
  </div>
</template>
